export const shouldOpenNewTab = () => {
  return (
    window.location.pathname.includes('public-displays') ||
    window.location.pathname.includes('muse-frame')
  );
};
